"use strict";

export function initInScope ($scope) {
   let $radioTabs = $scope.find('.js-radio-tab');

    $radioTabs.on('show.bs.tab', function (e) {
        let $this = $(this);

        let $radioInput = $this.find('.js-radio-tab__input');
        $radioInput.prop("checked", true);
    });

}